// Foundations
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

// Services
import { AnalyticsService } from 'src/app/services/analytics.service';
@Component({
  selector: 'app-content-header',
  templateUrl: './content-header.component.html',
  styleUrls: ['./content-header.component.scss']
})
export class ContentHeaderComponent implements OnInit {

  @Input() text = 'Content Header';
  @Input() showEdit = false;
  @Input() firebase = '';
  @Output() editClicked = new EventEmitter();

  constructor(
    private _analytics: AnalyticsService,
  ) { }

  ngOnInit(): void {
  }

  onEdit(): void {
    this._analytics.logButtonTap(this.firebase);
    this.editClicked.emit();
  }

}
